import script from "./FooterNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterNavigation.vue?vue&type=script&setup=true&lang=js"

import "./FooterNavigation.vue?vue&type=style&index=0&id=b7f2c60c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7f2c60c"]])

export default __exports__